'use client'

import { DataSettingOptions } from '@repo/sdk'
import * as React from 'react'
import { createContext, useContext, useState } from 'react'

type DataSettingContextType = {
  selectedDataSetting: string
  setSelectedDataSetting: (dataSetting: string) => void
}

const DataSettingContext = createContext<DataSettingContextType | null>(null)

export function DataSettingProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [selectedDataSetting, setSelectedDataSetting] = useState<string>(
    DataSettingOptions.D10_ULTIMATE_TRIAL,
  )

  const value = React.useMemo(() => ({
    selectedDataSetting,
    setSelectedDataSetting,
  }), [selectedDataSetting])

  return (
    <DataSettingContext.Provider value={value}>
      {children}
    </DataSettingContext.Provider>
  )
}

export function useDataSetting() {
  const context = useContext(DataSettingContext)
  if (!context) {
    throw new Error('useDataSetting must be used within a DataSettingProvider')
  }
  return context
}
